import * as fieldTypesDependencies from '~/services/fieldTypes';

// Manually defines field types used on API
// There is also an API route returning this, but mapping is still needed
// to connect API field types to Vue components, so it's done manually
export const inputText = {
    id: 1,
    name: 'Input Text',
    component: 'InputText',
    vueComponent: 'InputText',
    valueType: 'string',
    isSystem: false,
    searchable: true,
};

export const richText = {
    id: 2,
    name: 'Rich Text',
    component: 'RichText',
    vueComponent: 'RichText',
    valueType: 'text',
    isSystem: false,
    searchable: true,
};

export const image = {
    id: 3,
    name: 'Image',
    component: 'Image',
    vueComponent: 'FileUpload',
    valueType: 'string',
    isSystem: false,
    searchable: false,
};

export const booleanSwitch = {
    id: 4,
    name: 'Boolean',
    component: 'Boolean',
    vueComponent: 'BooleanSwitch',
    valueType: 'boolean',
    isSystem: false,
    searchable: true,
};

export const date = {
    id: 5,
    name: 'Date',
    component: 'Date',
    vueComponent: 'Calendar',
    valueType: 'timestamp',
    isSystem: false,
    searchable: true,
};

export const manyToOne = {
    id: 7,
    name: 'Many to One',
    component: 'ManyToOne',
    vueComponent: 'SelectBasic',
    valueType: 'integer',
    isSystem: false,
    searchable: true,
};

export const relationship = {
    id: 8,
    name: 'Relationship',
    component: 'Relationship',
    vueComponent: 'Relationship',
    valueType: '',
    isSystem: false,
    searchable: true,
};

export const password = {
    id: 9,
    name: 'Password',
    component: 'Password',
    vueComponent: 'InputPassword',
    valueType: 'string',
    isSystem: false,
    searchable: false,
};

export const integer = {
    id: 10,
    name: 'Integer',
    component: 'Integer',
    vueComponent: 'InputText',
    valueType: 'integer',
    isSystem: false,
    searchable: true,
};

export const systemInteger = {
    id: 11,
    name: 'System Integer',
    component: 'SystemInteger',
    vueComponent: 'InputText',
    valueType: 'integer',
    isSystem: true,
    searchable: false,
};

export const systemDateTime = {
    id: 12,
    name: 'System Date-time',
    component: 'SystemDateTime',
    vueComponent: 'DateTime',
    valueType: 'timestamp',
    isSystem: true,
    searchable: false,
};

export const systemString = {
    id: 13,
    name: 'System String',
    component: 'SystemString',
    vueComponent: 'InputText',
    valueType: 'string',
    isSystem: true,
    searchable: true,
};

export const oneToOne = {
    id: 14,
    name: 'One to One',
    component: 'OneToOne',
    vueComponent: 'SelectBasic',
    valueType: 'integer',
    isSystem: true,
    searchable: false,
};

export const asset = {
    id: 15,
    name: 'Asset',
    component: 'Asset',
    vueComponent: 'FileInput',
    valueType: 'string',
    isSystem: false,
    searchable: false,
};

export const oneToMany = {
    id: 17,
    name: 'One to Many',
    component: 'OneToMany',
    vueComponent: 'SelectTags',
    valueType: 'string',
    isSystem: false,
    searchable: false,
};

export const dateTime = {
    id: 18,
    name: 'Date-time',
    component: 'DateTime',
    vueComponent: 'DateTime',
    valueType: 'timestamp',
    isSystem: false,
    searchable: true,
};

export const permissions = {
    id: 24,
    name: 'Permissions',
    component: 'Permissions',
    vueComponent: 'Permissions',
    valueType: 'integer',
    isSystem: false,
    searchable: false,
};

export const bigInteger = {
    id: 25,
    name: 'Big Integer',
    component: 'BigInteger',
    vueComponent: 'InputText',
    valueType: 'bigInteger',
    isSystem: false,
    searchable: true,
};

export const textarea = {
    id: 26,
    name: 'Textarea',
    component: 'Textarea',
    vueComponent: 'Textarea',
    valueType: 'text',
    isSystem: false,
    searchable: true,
};

export const colorPicker = {
    id: 27,
    name: 'ColorPicker',
    component: 'ColorPicker',
    vueComponent: 'ColorPicker',
    valueType: 'text',
    isSystem: false,
    searchable: false,
};

export const location = {
    id: 29,
    name: 'Location',
    component: 'Location',
    vueComponent: 'Location',
    valueType: 'string',
    isSystem: false,
    searchable: false,
};

export const modulesMultiSelect = {
    id: 30,
    name: 'Modules Multi Select',
    component: 'ModulesMultiSelect',
    vueComponent: 'ModulesMultiSelect',
    valueType: 'integer',
    isSystem: false,
    searchable: false,
};

export const modulesSingleSelect = {
    id: 31,
    name: 'Modules Single Select',
    component: 'ModulesSingleSelect',
    vueComponent: 'ModulesSingleSelect',
    valueType: 'integer',
    isSystem: false,
    searchable: false,
};

export const section = {
    id: 32,
    name: 'Section',
    component: 'Section',
    vueComponent: 'Section',
    valueType: 'text',
    isSystem: false,
    searchable: false,
};

export const icon = {
    id: 33,
    name: 'Icon',
    component: 'Icon',
    vueComponent: 'Icon',
    valueType: 'text',
    isSystem: false,
    searchable: false,
};

export const simpleText = {
    id: 34,
    name: 'Simple Text',
    component: 'SimpleText',
    vueComponent: 'SimpleText',
    valueType: 'string',
    isSystem: false,
    searchable: true,
};

export const video = {
    id: 28,
    name: 'Video',
    vueComponent: 'Video',
    valueType: 'string',
    isSystem: false,
    searchable: false,
};

export const markdown = {
    id: 36,
    name: 'Markdown',
    component: 'Markdown',
    vueComponent: 'Markdown',
    valueType: 'text',
    isSystem: false,
    searchable: true,
};

// Field id to field object map
export const mapFromId = {
    ...fieldTypesDependencies.mapFromIdDependencies,
    1: inputText,
    2: richText,
    3: image,
    4: booleanSwitch,
    5: date,
    7: manyToOne,
    8: relationship,
    9: password,
    10: integer,
    11: systemInteger,
    12: systemDateTime,
    13: systemString,
    14: oneToOne,
    15: asset,
    17: oneToMany,
    18: dateTime,
    24: permissions,
    25: bigInteger,
    26: textarea,
    27: colorPicker,
    28: video,
    29: location,
    30: modulesMultiSelect,
    31: modulesSingleSelect,
    32: section,
    33: icon,
    34: simpleText,
    36: markdown,
};

/**
 * Helper function to generate field type options formatted for select2
 *
 * @return  {array}
 */
export const getFieldTypeOptionsSelect2 = function () {
    const options = [];

    for (let fieldTypeId in mapFromId) {
        // Skip the Image field type
        if (fieldTypeId == 3) {
            continue;
        }

        if (mapFromId.hasOwnProperty(fieldTypeId)) {
            options.push({
                id: fieldTypeId,
                text: mapFromId[fieldTypeId].name,
            });
        }
    }

    return options;
};
